import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import './search.m.css';
import ImageType3 from "../molecules/image-type-3";

const getQueryFromUrl = () => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("q") || "";
  }
  return "";
};

const SearchPage = (props) => {
  const { query } = props.data;
  const [orderedStories, setOrderedStories] = useState([]);
  const [queryValue, setQueryValue] = useState(getQueryFromUrl());
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isLoadMoreLoading, setIsLoadMoreLoading] = useState(false);
  const [totalResults, setTotalResults] = useState(props.data.total || 0);
  const limit = 20;

  const fetchStories = async (query, offset) => {
    const stories = await fetch(
      `/api/v1/advanced-search?q=${query}&limit=${limit}&offset=${offset}`
    );
    return await stories.json();
  };

  useEffect(() => {
    const callAPI = async () => {
      try {
        setLoading(true);
        const response = await fetchStories(queryValue, 0);
        const res = response?.items;
        setOrderedStories(res);
        setTotalResults(response?.total);
        setOffset(limit);
      } catch (error) {
        console.error("Failed to fetch search results:", error);
      } finally {
        setLoading(false);
      }
    };

    if (queryValue) {
      callAPI();
    } else {
      setLoading(false);
    }
  }, [queryValue]);

  const handleLoadMore = async () => {
    setIsLoadMoreLoading(true);
    try {
      const response = await fetchStories(queryValue, offset);
      const newStories = response?.items;
      setOrderedStories([...orderedStories, ...newStories]);
      setOffset(offset + limit);
    } catch (error) {
      console.error("Failed to load more stories:", error);
    } finally {
      setIsLoadMoreLoading(false);
    }
  };

  return (
    <React.Fragment>
      <h2 styleName="search-results">
        {`Haku - '${queryValue}' (Yhteensä ${totalResults} tulosta)`}
      </h2>

      <div styleName="search-wrapper">
        {loading ? (
          <div styleName="loading">Ladataan...</div>
        ) : orderedStories?.length > 0 ? (
          orderedStories?.map((story) => (
            <div key={story?.id}>
              <ImageType3
                story={story}
                showDateSection={false}
                isSearchPage={true}
              />
            </div>
          ))
        ) : (
          <div styleName="no-results">Ei tuloksia löytynyt.</div>
        )}

        {orderedStories?.length > 0 && orderedStories?.length < totalResults && (
          <button styleName="loadmore-btn" onClick={handleLoadMore} disabled={isLoadMoreLoading}>
            {isLoadMoreLoading ? "Ladataan..." : "Lataa lisää"}
          </button>
        )}
      </div>
    </React.Fragment>
  );
};

SearchPage.propTypes = {
  data: PropTypes.object,
};

export { SearchPage };
